import _ from "lodash";
import initialState from "./initialState";

export default (state = initialState.entities, action) => {
  if (action.entities) {
    return _.merge({}, state, action.entities);
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/entities.js